import { config as authConfig } from './auth.config';
import { config as appConfig } from './app.config';
import { formScale } from './form.config';
import { firebaseConfig } from './firebase.config';

const config = {
  ...authConfig,
  ...appConfig,
  firebaseConfig,
  formScale
};

export default config;
